import {
  GET_USER_INFO,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO_FAILED,
  GET_SELECTED_CODE,
  GET_GUID,
} from "./actionsTypes";

export const getUserInfo = (params) => {
  return {
    type: GET_USER_INFO,
    payload: params,
  };
};

export const getUserInfoSuccess = (users) => {
  return {
    type: GET_USER_INFO_SUCCESS,
    payload: users,
  };
};

export const getUserInfoFailed = (error) => {
  return {
    type: GET_USER_INFO_FAILED,
    payload: error,
  };
};

export const getSelectedCode = (code) => {
  return {
    type: GET_SELECTED_CODE,
    payload: code,
  };
};

export const getGUID = (guid) => {
  return {
    type: GET_GUID,
    payload: guid,
  };
};
